export default __webpack_public_path__ + "static/media/ninja.83e2c6c3.png";